// extracted by mini-css-extract-plugin
export default {"pane":"Pane_pane__ui5SD"};